<template>
    <b-overlay rounded="sm">
        <div>
            <ReportsDialog ref="reportsDialog" :report-list="reportList" :query="reportQuery" />
            <list-items v-if="isList" :title="title" :items="assets" :crm="crm" :crm-setting-value="crmSettingValue"
                ref="table" :officers="officers" :roles="roles" :types="types">
                <import-form :subject="$translate('assets')" v-model="importModal" @cancel="hideModal()"
                    :fields="assetFields" :upload-record="uploadAssetRecord"
                    settings-key-name="assetUploadKey"></import-form>

                <page-actions :buttons-actions="buttonActions" control-class="float-right" control-size="sm" />
            </list-items>

            <view-item :id="id" :crm="crm" @success="alertSuccess" @error="showError" :officers="officers" :types="types"
                v-else></view-item>
        </div>
    </b-overlay>
</template>
<script>
import ListItems from './ListItems'
import ViewItem from './ViewItem'
import ImportForm from '@/components/ImportForm.vue'
import ReportsDialog from '@/components/ReportsDialog'

import PageActions from '@/components/PageActions.vue'
import _ from 'lodash'

import popupMixins from '@/mixins/popupMixins'
import showItemHelper from '@/mixins/showItemHelper'
import permissionsMixins from '@/mixins/permissionsMixins'
import importMixins from '@/mixins/importMixins'
import { templates } from '@/exports/jsreport_templates'
import download from '@/assets/images/icon/export.svg'
import upload from '@/assets/images/icon/import.svg'
import add from '@/assets/images/icon/gradient-add.svg'
import { capitalCase } from 'change-case'

export default {
    name: 'assets',
    components: {
        ListItems,
        ViewItem,
        ImportForm,
        PageActions,
        ReportsDialog,
    },
    mixins: [popupMixins, showItemHelper, permissionsMixins, importMixins],
    data: () => {
        return {
            importModal: false,
            ListItems,
            item: null,
            filters: {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
            },
            reportQuery: null,
        }
    },

    computed: {
        assetFields() {
            return [
                { name: 'name', label: this.$translate('name'), required: true, type: 'text' },
                { name: 'model_no', label: this.$translate('model_no'), required: true, type: 'text' },
                { name: 'serial_no', label: this.$translate('serial_no'), required: false, type: 'text' },
                { name: 'asset_type_name', label: this.$translate('asset_type_name'), required: true, type: 'text' },
                { name: 'customer_code', label: this.$translate('customer_code'), required: true, type: 'text' },
                { name: 'manufacturer_name', label: this.$translate('manufacturer_name'), required: true, type: 'text' },
                { name: 'vendor', label: this.$translate('vendor'), required: true, type: 'text' },
                { name: 'last_service_date', label: this.$translate('last_service_date'), required: false, type: 'text' },
                { name: 'next_service_date', label: this.$translate('next_service_date'), required: false, type: 'text' },
                { name: 'warranty_expiry_date', label: this.$translate('warranty_expiry_date'), required: false, type: 'text' },
                { name: 'contract_expiry_date', label: this.$translate('contract_expiry_date'), required: false, type: 'text' },
                { name: 'country_code', label: this.$translate('country_region'), required:true, type: 'text' },
                { name: 'state_name', label: this.$translate('state'), required:false, type: 'text' },
                { name: 'address1', label: this.$translate('address'), required:true, type: 'text' },
                { name: 'city', label: this.$translate('city'), required:true, type:'text' },
                { name: 'postal_code', label: this.$translate('postal_code'), required:false, type: 'text' },
                { name: 'zip_code', label: this.$translate('zip_code'), required:false, type: 'text' },
                { name: 'frequency', label: this.$translate('frequency'), required: false, type: 'text' },
                { name: 'description', label: this.$translate('description'), required: false, type: 'text' },
                { name: 'service_week_day', label: this.$translate('service_week_day'), required: false, type: 'text' },
                { name: 'service_time_of_day', label: this.$translate('service_time_of_day'), required: false, type: 'text' },
                { name: 'default_engineer_id', label: this.$translate('default_engineer_id'), required: false, type: 'text' },
            ]
        },
        componentName() { return this.$translate('asset') },
        user() {
            return this.$store.state.user
        },
        engineers() {
            return this.$store.getters['users/all_admin_users']
        },
        roles() {
            return this.$store.state.roles.items
        },
        title() {
            const { crm } = this
            return crm ? this.$translate('crm_tasks') : this.$translate('assets_management')
        },
        assets() {
            const _assets = this.$store.state.assets.assets
            console.log('assets-----', _assets)
            return _assets
        },
        types() {
            const { type_id } = this.crmSettingValue
            const { crm } = this
            const _types = this.$store.state.assets.types || []
            const filteredTypes = _types.filter(x =>
                crm ? x.id == type_id : x.id != type_id
            )
            console.log('filteredTypes-------', filteredTypes)
            return filteredTypes
        },

        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        vendors() {
            return this.$store.state.assets.vendors
        },
        newRoute() {
            return this.$route.path + '/' + this.id + '/usage'
        },

        freqSettingKey() {
            return this.$store.state.company.settingKeys.assetFrequencyKey
        },
        buttonActions() {
            const actions = []
            const { crm } = this

            if (this.crm) {
                actions.push({
                    action: () => this.showReportsDialog(),
                    icon: 'download',
                    img: download,
                    variant: 'light',
                    class: 'btn-blue-icon me-2',
                    tooltip: this.$translate('crm_report'),
                })
            }

            if (this.hasPermissionCreate) {
                actions.push({
                    action: () => this.createNewAsset(),
                    icon: 'plus-circle',
                    img: add,
                    variant: 'pink-button',
                    class: 'btn-blue-icon me-2',
                    tooltip: crm ? this.$translate('create_new_crm') : this.$translate('create_new_asset'),
                })
            }

            if (this.hasPermissionCreate && !this.crm) {
                actions.push({
                    action: () => this.importOrders(),
                    icon: 'upload',
                    img: upload,
                    class: 'btn-blue-icon me-2',
                    tooltip: this.$translate('import_assets'),
                })
            }
            if (this.hasPermissionView && !this.crm) {
                actions.push({
                    action: () => this.exportOrders(),
                    icon: 'download',
                    img: download,
                    class: 'btn-blue-icon me-2',
                    tooltip: this.$translate('export_assets'),
                })
            }
            return actions
        },
        crmSettingValue() {
            return this.$store.getters['company/crmSettingValue']
        },
        crmsettingsKey() {
            return this.$store.state.company.settingKeys.crmsettingsKey
        },
        crm() {
            return this.$route.name.slice(0, 3) === 'crm'
        },
        reportList() {
            return [
                {
                    id: 'crm_report',
                    value: templates.RPT_SVR_CRM_TEMPLATE,
                    extension: 'xlsx',
                    name: 'CRM Report',
                },
            ]
        },
    },

    watch: {
        crm: function () {
            this.$nextTick(() => {
                this.$refs.table.pureSearch(true)
            })
        },
    },

    created() {
        console.log(' this.freqSettingKey', this.freqSettingKey)
        this.$store.dispatch('company/fetchConfiguration', this.freqSettingKey)
        this.$store.dispatch('roles/fetchAll')
        this.$store.dispatch('assets/listTypes')
        this.$store.dispatch('interactionType/fetchAll')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('locations/fetchWarehouses')
    },
    mounted() {
        console.log('asset  route', this.$route)
        console.log('user', this.user)

        this.$store.dispatch('company/fetchConfiguration', this.crmsettingsKey)

        this.$store.dispatch('users/fetchAll')
    },

    methods: {
        showReportsDialog() {
            this.reportQuery =
                this.$refs.table && this.$refs.table.getCrmQuery()
            this.$nextTick(() => {
                this.$refs.reportsDialog.show()
            })
        },
        alertSuccess(action, message, assetName) {
            this.genericToast(
                this.componentName,
                this.$translate(`${action}d`),
                'success',
                `${assetName} ${message}`
            )
            this.item = null
            this.doSearch()
        },

        showError(error) {
            this.doToast(this.$translate('error'), `${error}`, 'danger')
        },
        doSearch: _.debounce(async function () {
            await this.pureSearch()
        }, 500),

        async pureSearch() {
            let {
                query,
                filters,
                crm,
                crmSettingValue: { type_id },
            } = this
            if (crm) {
                this.$set(filters, 'type_id', type_id || null)
                this.$set(filters, 'warranty_from', null)
                this.$set(filters, 'warranty_to', null)
            } else {
                this.$set(filters, 'type_id', null)
            }
            this.$set(filters, 'crm_type_id', type_id || null)

            await this.$store.dispatch('assets/fetch', {
                query,
                // page,
                filters,
            })
            this.$router.go(-1)
        },

        createNewAsset() {
            this.$router.push(`${this.$route.path}/0`)
        },
        importOrders() {
            this.importModal = true
        },
        exportOrders() {
            this.$refs.table.showDetailsDialog()
        },
        async uploadAssetRecord(
            dataRecord,
            statusRecord,
            { check, field, message },
            statuses,
            setLoading
        ) {
            try {
                console.log(":dataRecord", dataRecord, statusRecord, statuses)
                let {
                    name,
                    asset_type_name,
                    serial_no,
                    country_code,
                    city,
                    address1,
                    state_name,
                    postal_code,
                    zip_code,
                    model_no,
                    manufacturer_name,
                    customer_code,
                    description,
                    vendor: vendor_name,
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    frequency,
                    service_week_day,
                    service_time_of_day,
                    contract_expiry_date,
                    default_engineer_id,
                } = dataRecord



                statusRecord.status = statuses.CHECKING

                console.log('check', check)
                if (check != 1) throw new Error(`${field}-${message}`)

                const vendor_id = this.getCustomEntityId(
                    vendor_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )
                const manufacturer_id = this.getCustomEntityId(
                    manufacturer_name,
                    this.vendors,
                    'name',
                    'Vendor'
                )

                const type_id = this.getCustomEntityId(
                    asset_type_name,
                    this.types,
                    'name',
                    'asset_type'
                )

                default_engineer_id = default_engineer_id || null
                contract_expiry_date = contract_expiry_date || null
                next_service_date = next_service_date || null
                const notes = null
                const manual_url = null
                const service_plan_url = null
                const image_url = null
                const order_template_id = null

                const parsedWeekDay = service_week_day.toLowerCase().trim()
                switch (parsedWeekDay) {
                    case 'sunday':
                        service_week_day = 0
                        break
                    case 'monday':
                        service_week_day = 1
                        break
                    case 'tuesday':
                        service_week_day = 2
                        break
                    case 'wednesday':
                        service_week_day = 3
                        break
                    case 'thursday':
                        service_week_day = 4
                        break
                    case 'friday':
                        service_week_day = 5
                        break
                    case 'saturday':
                        service_week_day = 6
                        break
                    default: {
                        if (
                            service_week_day != 0 ||
                            service_week_day != 1 ||
                            service_week_day != 2 ||
                            service_week_day != 3 ||
                            service_week_day != 4 ||
                            service_week_day != 5 ||
                            service_week_day != 6
                        ) {
                            service_week_day = null
                        }
                    }
                }
                console.log('service_week_day after:', service_week_day)
                if (service_time_of_day || service_time_of_day == 0) {
                    let [hr, min] = (service_time_of_day || '').split(':')
                    hr = hr || 0
                    min = min || 0
                    hr = isNaN(parseInt(hr)) ? 0 : parseInt(hr)
                    min = isNaN(parseInt(min)) ? 0 : parseInt(min)
                    service_time_of_day = min + 60 * hr
                } else {
                    service_time_of_day = null
                }

                if (
                    default_engineer_id &&
                    isNaN(parseInt(default_engineer_id))
                ) {
                    console.log('this.engineers', this.engineers)
                    const [fn, ln] = default_engineer_id.split(' ')
                    console.log({ fn, ln })
                    const sel = this.engineers.find(
                        x =>
                            x.first_name.toLowerCase() == fn.toLowerCase() &&
                            x.last_name.toLowerCase() == ln.toLowerCase()
                    )
                    if (sel) {
                        default_engineer_id = sel.id
                    } else {
                        throw new Error('Engineer Not Found!')
                    }
                }

                /////////////////////check date
                const dates = {
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    contract_expiry_date,
                }

                for (const key in dates) {
                    if (dates[key] && !/^\d{4}-\d{2}-\d{2}$/.test(dates[key])) {
                        throw new Error(
                            `${capitalCase(
                                key
                            )} must be in this format YYYY-MM-DD`
                        )
                    }
                }

                const payload = {
                    name,
                    type_id,
                    serial_no,
                    model_no,
                    manufacturer_id,
                    customer_code,
                    location: {
                        country_code,
                        city,
                        postal_code,
                        zip_code,
                        address1,
                        state_name
                    },
                    // customer_id,
                    vendor_id,
                    warranty_expiry_date,
                    last_service_date,
                    next_service_date,
                    // location_section_id,
                    frequency,
                    description,
                    service_week_day,
                    service_time_of_day,
                    contract_expiry_date,
                    default_engineer_id,
                    notes,
                    manual_url,
                    service_plan_url,
                    image_url,
                    order_template_id,
            }

                console.log('Parameters:', payload)

            const res = await this.$store.dispatch('assets/create', {
                payload,
            })

            console.log('response:', res)

            // set status to complete if the upload was successful
            statusRecord.status = statuses.COMPLETE
        } catch(err) {
            /*  console.error('err', err)
            statusRecord.error_list =
                typeof err.message == 'string'
                    ? [err.message]
                    : Object.entries(err.message)
            statusRecord.status = statuses.ERROR */
            console.error('err', err)
            if (
                err.message.indexOf('Integrity constraint violation') >=
                0 &&
                err.message.indexOf('location_section_id') >= 0
            ) {
                statusRecord.error_list = [
                    ['error', ['Customer Location cannot be Null!']],
                ]
            } else if (typeof err.message == 'string') {
                statusRecord.error_list = [['error', [err.message]]]
            } else {
                statusRecord.error_list = Object.entries(err.message)
            }

            statusRecord.status = statuses.ERROR
        } finally {
            setLoading(false)
        }
    },
},
}
</script>
<style></style>
